module.exports = __webpack_public_path__ + "img/9788959525751.a15625ea.jpg";